import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';

// Create Task (Handles File Upload)
export const createTask = createAsyncThunk(
    'task/create',
    async (data: any, { rejectWithValue }) => {
        try {
            const formData = new FormData();
            Object.entries(data).forEach(([key, value]) => {
                if (value === undefined || value === null) {
                    return;
                }

                if (value instanceof File || value instanceof Blob) {
                    formData.append(key, value);
                }
                else if (typeof value === 'object') {
                    formData.append(key, JSON.stringify(value));
                }
                else {
                    formData.append(key, value.toString());
                }
            });

            const response = await employeeServiceApiInstance.post('/task', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });

            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to create task');
        }
    }
);
// Fetch All Tasks
export const fetchTasks = createAsyncThunk(
    'task/fetchAll',
    async (_, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get('/task');
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch tasks');
        }
    }
);

// Fetch Task by ID
export const fetchTaskById = createAsyncThunk(
    'task/fetchById',
    async (taskId: number, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/task/${taskId}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch task');
        }
    }
);
// Fetch Task by project id
export const fetchTaskByProjectId = createAsyncThunk(
    'task/fetchTaskByProjectId',
    async (projectid: number, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/task/project/${projectid}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch project task');
        }
    }
);

// Update Task (Handles File Upload)
export const updateTask = createAsyncThunk(
    'task/update',
    async ({ taskId, ...data }: any & { taskId: number }, { rejectWithValue }) => {
        try {
            const formData = new FormData();
            Object.entries(data).forEach(([key, value]) => {
                if (value === undefined || value === null) {
                    return;
                }

                if (value instanceof File || value instanceof Blob) {
                    formData.append(key, value);
                }
                else if (typeof value === 'object') {
                    formData.append(key, JSON.stringify(value));
                }
                else {
                    formData.append(key, value.toString());
                }
            });
            const response = await employeeServiceApiInstance.put(`/task/${taskId}`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });

            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to update task');
        }
    }
);


// Delete Task
export const deleteTask = createAsyncThunk(
    'task/delete',
    async (taskId: number, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.delete(`/task/${taskId}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to delete task');
        }
    }
);

export const fetchTasksByEmployeeId = createAsyncThunk(
    'task/fetchByEmployeeId',
    async (employeeId: number, { rejectWithValue }) => {
      try {
        const response = await employeeServiceApiInstance.get(`/task/employee/${employeeId}`);
        return response.data;
      } catch (error: any) {
        return rejectWithValue(error.response?.data || 'Failed to fetch tasks for this employee');
      }
    }
  );
